package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings12 {
  internal val title_activity_mikud: StringResource by lazy { init_title_activity_mikud() }

  internal val title_activity_settings: StringResource by lazy { init_title_activity_settings() }

  internal val title_random_verse: StringResource by lazy { init_title_random_verse() }

  internal val title_settings_format: StringResource by lazy { init_title_settings_format() }

  internal val toolbar_menu_back_button: StringResource by lazy { init_toolbar_menu_back_button() }

  internal val toolbar_menu_more_options: StringResource by lazy { init_toolbar_menu_more_options()
      }

  internal val topic: StringResource by lazy { init_topic() }

  internal val topics_found_in_spreadsheet: StringResource by lazy {
      init_topics_found_in_spreadsheet() }

  internal val total_chapters: StringResource by lazy { init_total_chapters() }

  internal val total_chapters_format: StringResource by lazy { init_total_chapters_format() }

  internal val tradition: StringResource by lazy { init_tradition() }

  internal val type_at_least_two_letters: StringResource by lazy { init_type_at_least_two_letters()
      }

  internal val type_expression_to_search: StringResource by lazy { init_type_expression_to_search()
      }

  internal val type_next_word_underlined: StringResource by lazy { init_type_next_word_underlined()
      }

  internal val unable_to_check_for_updates: StringResource by lazy {
      init_unable_to_check_for_updates() }

  internal val unable_to_check_for_updates_message: StringResource by lazy {
      init_unable_to_check_for_updates_message() }

  internal val unable_to_download_the_requested_page: StringResource by lazy {
      init_unable_to_download_the_requested_page() }

  internal val undo: StringResource by lazy { init_undo() }

  internal val update_available: StringResource by lazy { init_update_available() }

  internal val update_available_version_format: StringResource by lazy {
      init_update_available_version_format() }

  internal val update_now: StringResource by lazy { init_update_now() }

  internal val upgrade: StringResource by lazy { init_upgrade() }

  internal val upgrade_message: StringResource by lazy { init_upgrade_message() }

  internal val upgrade_to_full_version: StringResource by lazy { init_upgrade_to_full_version() }

  internal val `value`: StringResource by lazy { init_value() }

  internal val verse_completed: StringResource by lazy { init_verse_completed() }

  internal val verse_copied_to_clipboard: StringResource by lazy { init_verse_copied_to_clipboard()
      }

  internal val verse_copy: StringResource by lazy { init_verse_copy() }

  internal val verse_value: StringResource by lazy { init_verse_value() }

  internal val verse_widget: StringResource by lazy { init_verse_widget() }

  internal val verse_widget_active: StringResource by lazy { init_verse_widget_active() }

  internal val verse_widget_add: StringResource by lazy { init_verse_widget_add() }

  internal val verse_widget_book_title: StringResource by lazy { init_verse_widget_book_title() }

  internal val verse_widget_description: StringResource by lazy { init_verse_widget_description() }

  internal val verse_widget_example_button: StringResource by lazy {
      init_verse_widget_example_button() }

  internal val verse_widget_example_error: StringResource by lazy {
      init_verse_widget_example_error() }

  internal val verse_widget_example_image: StringResource by lazy {
      init_verse_widget_example_image() }

  internal val verse_widget_example_retry: StringResource by lazy {
      init_verse_widget_example_retry() }

  internal val verse_widget_got_it: StringResource by lazy { init_verse_widget_got_it() }

  internal val verse_widget_instructions_android: StringResource by lazy {
      init_verse_widget_instructions_android() }

  internal val verse_widget_instructions_ios: StringResource by lazy {
      init_verse_widget_instructions_ios() }

  internal val verse_widget_instructions_title: StringResource by lazy {
      init_verse_widget_instructions_title() }

  internal val verse_widget_interval_10m: StringResource by lazy { init_verse_widget_interval_10m()
      }

  internal val verse_widget_interval_12h: StringResource by lazy { init_verse_widget_interval_12h()
      }

  internal val verse_widget_interval_15m: StringResource by lazy { init_verse_widget_interval_15m()
      }

  internal val verse_widget_interval_1d: StringResource by lazy { init_verse_widget_interval_1d() }

  internal val verse_widget_interval_1h: StringResource by lazy { init_verse_widget_interval_1h() }

  internal val verse_widget_interval_30m: StringResource by lazy { init_verse_widget_interval_30m()
      }

  internal val verse_widget_interval_3h: StringResource by lazy { init_verse_widget_interval_3h() }

  internal val verse_widget_interval_5m: StringResource by lazy { init_verse_widget_interval_5m() }

  internal fun values(): List<StringResource> = listOf(title_activity_mikud,
      title_activity_settings, title_random_verse, title_settings_format, toolbar_menu_back_button,
      toolbar_menu_more_options, topic, topics_found_in_spreadsheet, total_chapters,
      total_chapters_format, tradition, type_at_least_two_letters, type_expression_to_search,
      type_next_word_underlined, unable_to_check_for_updates, unable_to_check_for_updates_message,
      unable_to_download_the_requested_page, undo, update_available,
      update_available_version_format, update_now, upgrade, upgrade_message,
      upgrade_to_full_version, value, verse_completed, verse_copied_to_clipboard, verse_copy,
      verse_value, verse_widget, verse_widget_active, verse_widget_add, verse_widget_book_title,
      verse_widget_description, verse_widget_example_button, verse_widget_example_error,
      verse_widget_example_image, verse_widget_example_retry, verse_widget_got_it,
      verse_widget_instructions_android, verse_widget_instructions_ios,
      verse_widget_instructions_title, verse_widget_interval_10m, verse_widget_interval_12h,
      verse_widget_interval_15m, verse_widget_interval_1d, verse_widget_interval_1h,
      verse_widget_interval_30m, verse_widget_interval_3h, verse_widget_interval_5m)
}

private fun init_title_activity_mikud(): StringResource = StringResource(key =
    "title_activity_mikud", loader = stringsLoader)

private fun init_title_activity_settings(): StringResource = StringResource(key =
    "title_activity_settings", loader = stringsLoader)

private fun init_title_random_verse(): StringResource = StringResource(key = "title_random_verse",
    loader = stringsLoader)

private fun init_title_settings_format(): StringResource = StringResource(key =
    "title_settings_format", loader = stringsLoader)

private fun init_toolbar_menu_back_button(): StringResource = StringResource(key =
    "toolbar_menu_back_button", loader = stringsLoader)

private fun init_toolbar_menu_more_options(): StringResource = StringResource(key =
    "toolbar_menu_more_options", loader = stringsLoader)

private fun init_topic(): StringResource = StringResource(key = "topic", loader = stringsLoader)

private fun init_topics_found_in_spreadsheet(): StringResource = StringResource(key =
    "topics_found_in_spreadsheet", loader = stringsLoader)

private fun init_total_chapters(): StringResource = StringResource(key = "total_chapters", loader =
    stringsLoader)

private fun init_total_chapters_format(): StringResource = StringResource(key =
    "total_chapters_format", loader = stringsLoader)

private fun init_tradition(): StringResource = StringResource(key = "tradition", loader =
    stringsLoader)

private fun init_type_at_least_two_letters(): StringResource = StringResource(key =
    "type_at_least_two_letters", loader = stringsLoader)

private fun init_type_expression_to_search(): StringResource = StringResource(key =
    "type_expression_to_search", loader = stringsLoader)

private fun init_type_next_word_underlined(): StringResource = StringResource(key =
    "type_next_word_underlined", loader = stringsLoader)

private fun init_unable_to_check_for_updates(): StringResource = StringResource(key =
    "unable_to_check_for_updates", loader = stringsLoader)

private fun init_unable_to_check_for_updates_message(): StringResource = StringResource(key =
    "unable_to_check_for_updates_message", loader = stringsLoader)

private fun init_unable_to_download_the_requested_page(): StringResource = StringResource(key =
    "unable_to_download_the_requested_page", loader = stringsLoader)

private fun init_undo(): StringResource = StringResource(key = "undo", loader = stringsLoader)

private fun init_update_available(): StringResource = StringResource(key = "update_available",
    loader = stringsLoader)

private fun init_update_available_version_format(): StringResource = StringResource(key =
    "update_available_version_format", loader = stringsLoader)

private fun init_update_now(): StringResource = StringResource(key = "update_now", loader =
    stringsLoader)

private fun init_upgrade(): StringResource = StringResource(key = "upgrade", loader = stringsLoader)

private fun init_upgrade_message(): StringResource = StringResource(key = "upgrade_message", loader
    = stringsLoader)

private fun init_upgrade_to_full_version(): StringResource = StringResource(key =
    "upgrade_to_full_version", loader = stringsLoader)

private fun init_value(): StringResource = StringResource(key = "value", loader = stringsLoader)

private fun init_verse_completed(): StringResource = StringResource(key = "verse_completed", loader
    = stringsLoader)

private fun init_verse_copied_to_clipboard(): StringResource = StringResource(key =
    "verse_copied_to_clipboard", loader = stringsLoader)

private fun init_verse_copy(): StringResource = StringResource(key = "verse_copy", loader =
    stringsLoader)

private fun init_verse_value(): StringResource = StringResource(key = "verse_value", loader =
    stringsLoader)

private fun init_verse_widget(): StringResource = StringResource(key = "verse_widget", loader =
    stringsLoader)

private fun init_verse_widget_active(): StringResource = StringResource(key = "verse_widget_active",
    loader = stringsLoader)

private fun init_verse_widget_add(): StringResource = StringResource(key = "verse_widget_add",
    loader = stringsLoader)

private fun init_verse_widget_book_title(): StringResource = StringResource(key =
    "verse_widget_book_title", loader = stringsLoader)

private fun init_verse_widget_description(): StringResource = StringResource(key =
    "verse_widget_description", loader = stringsLoader)

private fun init_verse_widget_example_button(): StringResource = StringResource(key =
    "verse_widget_example_button", loader = stringsLoader)

private fun init_verse_widget_example_error(): StringResource = StringResource(key =
    "verse_widget_example_error", loader = stringsLoader)

private fun init_verse_widget_example_image(): StringResource = StringResource(key =
    "verse_widget_example_image", loader = stringsLoader)

private fun init_verse_widget_example_retry(): StringResource = StringResource(key =
    "verse_widget_example_retry", loader = stringsLoader)

private fun init_verse_widget_got_it(): StringResource = StringResource(key = "verse_widget_got_it",
    loader = stringsLoader)

private fun init_verse_widget_instructions_android(): StringResource = StringResource(key =
    "verse_widget_instructions_android", loader = stringsLoader)

private fun init_verse_widget_instructions_ios(): StringResource = StringResource(key =
    "verse_widget_instructions_ios", loader = stringsLoader)

private fun init_verse_widget_instructions_title(): StringResource = StringResource(key =
    "verse_widget_instructions_title", loader = stringsLoader)

private fun init_verse_widget_interval_10m(): StringResource = StringResource(key =
    "verse_widget_interval_10m", loader = stringsLoader)

private fun init_verse_widget_interval_12h(): StringResource = StringResource(key =
    "verse_widget_interval_12h", loader = stringsLoader)

private fun init_verse_widget_interval_15m(): StringResource = StringResource(key =
    "verse_widget_interval_15m", loader = stringsLoader)

private fun init_verse_widget_interval_1d(): StringResource = StringResource(key =
    "verse_widget_interval_1d", loader = stringsLoader)

private fun init_verse_widget_interval_1h(): StringResource = StringResource(key =
    "verse_widget_interval_1h", loader = stringsLoader)

private fun init_verse_widget_interval_30m(): StringResource = StringResource(key =
    "verse_widget_interval_30m", loader = stringsLoader)

private fun init_verse_widget_interval_3h(): StringResource = StringResource(key =
    "verse_widget_interval_3h", loader = stringsLoader)

private fun init_verse_widget_interval_5m(): StringResource = StringResource(key =
    "verse_widget_interval_5m", loader = stringsLoader)

public actual val SharedRes.strings.title_activity_mikud: StringResource
  get() = CommonMainStrings12.title_activity_mikud

public actual val SharedRes.strings.title_activity_settings: StringResource
  get() = CommonMainStrings12.title_activity_settings

public actual val SharedRes.strings.title_random_verse: StringResource
  get() = CommonMainStrings12.title_random_verse

public actual val SharedRes.strings.title_settings_format: StringResource
  get() = CommonMainStrings12.title_settings_format

public actual val SharedRes.strings.toolbar_menu_back_button: StringResource
  get() = CommonMainStrings12.toolbar_menu_back_button

public actual val SharedRes.strings.toolbar_menu_more_options: StringResource
  get() = CommonMainStrings12.toolbar_menu_more_options

public actual val SharedRes.strings.topic: StringResource
  get() = CommonMainStrings12.topic

public actual val SharedRes.strings.topics_found_in_spreadsheet: StringResource
  get() = CommonMainStrings12.topics_found_in_spreadsheet

public actual val SharedRes.strings.total_chapters: StringResource
  get() = CommonMainStrings12.total_chapters

public actual val SharedRes.strings.total_chapters_format: StringResource
  get() = CommonMainStrings12.total_chapters_format

public actual val SharedRes.strings.tradition: StringResource
  get() = CommonMainStrings12.tradition

public actual val SharedRes.strings.type_at_least_two_letters: StringResource
  get() = CommonMainStrings12.type_at_least_two_letters

public actual val SharedRes.strings.type_expression_to_search: StringResource
  get() = CommonMainStrings12.type_expression_to_search

public actual val SharedRes.strings.type_next_word_underlined: StringResource
  get() = CommonMainStrings12.type_next_word_underlined

public actual val SharedRes.strings.unable_to_check_for_updates: StringResource
  get() = CommonMainStrings12.unable_to_check_for_updates

public actual val SharedRes.strings.unable_to_check_for_updates_message: StringResource
  get() = CommonMainStrings12.unable_to_check_for_updates_message

public actual val SharedRes.strings.unable_to_download_the_requested_page: StringResource
  get() = CommonMainStrings12.unable_to_download_the_requested_page

public actual val SharedRes.strings.undo: StringResource
  get() = CommonMainStrings12.undo

public actual val SharedRes.strings.update_available: StringResource
  get() = CommonMainStrings12.update_available

public actual val SharedRes.strings.update_available_version_format: StringResource
  get() = CommonMainStrings12.update_available_version_format

public actual val SharedRes.strings.update_now: StringResource
  get() = CommonMainStrings12.update_now

public actual val SharedRes.strings.upgrade: StringResource
  get() = CommonMainStrings12.upgrade

public actual val SharedRes.strings.upgrade_message: StringResource
  get() = CommonMainStrings12.upgrade_message

public actual val SharedRes.strings.upgrade_to_full_version: StringResource
  get() = CommonMainStrings12.upgrade_to_full_version

public actual val SharedRes.strings.`value`: StringResource
  get() = CommonMainStrings12.value

public actual val SharedRes.strings.verse_completed: StringResource
  get() = CommonMainStrings12.verse_completed

public actual val SharedRes.strings.verse_copied_to_clipboard: StringResource
  get() = CommonMainStrings12.verse_copied_to_clipboard

public actual val SharedRes.strings.verse_copy: StringResource
  get() = CommonMainStrings12.verse_copy

public actual val SharedRes.strings.verse_value: StringResource
  get() = CommonMainStrings12.verse_value

public actual val SharedRes.strings.verse_widget: StringResource
  get() = CommonMainStrings12.verse_widget

public actual val SharedRes.strings.verse_widget_active: StringResource
  get() = CommonMainStrings12.verse_widget_active

public actual val SharedRes.strings.verse_widget_add: StringResource
  get() = CommonMainStrings12.verse_widget_add

public actual val SharedRes.strings.verse_widget_book_title: StringResource
  get() = CommonMainStrings12.verse_widget_book_title

public actual val SharedRes.strings.verse_widget_description: StringResource
  get() = CommonMainStrings12.verse_widget_description

public actual val SharedRes.strings.verse_widget_example_button: StringResource
  get() = CommonMainStrings12.verse_widget_example_button

public actual val SharedRes.strings.verse_widget_example_error: StringResource
  get() = CommonMainStrings12.verse_widget_example_error

public actual val SharedRes.strings.verse_widget_example_image: StringResource
  get() = CommonMainStrings12.verse_widget_example_image

public actual val SharedRes.strings.verse_widget_example_retry: StringResource
  get() = CommonMainStrings12.verse_widget_example_retry

public actual val SharedRes.strings.verse_widget_got_it: StringResource
  get() = CommonMainStrings12.verse_widget_got_it

public actual val SharedRes.strings.verse_widget_instructions_android: StringResource
  get() = CommonMainStrings12.verse_widget_instructions_android

public actual val SharedRes.strings.verse_widget_instructions_ios: StringResource
  get() = CommonMainStrings12.verse_widget_instructions_ios

public actual val SharedRes.strings.verse_widget_instructions_title: StringResource
  get() = CommonMainStrings12.verse_widget_instructions_title

public actual val SharedRes.strings.verse_widget_interval_10m: StringResource
  get() = CommonMainStrings12.verse_widget_interval_10m

public actual val SharedRes.strings.verse_widget_interval_12h: StringResource
  get() = CommonMainStrings12.verse_widget_interval_12h

public actual val SharedRes.strings.verse_widget_interval_15m: StringResource
  get() = CommonMainStrings12.verse_widget_interval_15m

public actual val SharedRes.strings.verse_widget_interval_1d: StringResource
  get() = CommonMainStrings12.verse_widget_interval_1d

public actual val SharedRes.strings.verse_widget_interval_1h: StringResource
  get() = CommonMainStrings12.verse_widget_interval_1h

public actual val SharedRes.strings.verse_widget_interval_30m: StringResource
  get() = CommonMainStrings12.verse_widget_interval_30m

public actual val SharedRes.strings.verse_widget_interval_3h: StringResource
  get() = CommonMainStrings12.verse_widget_interval_3h

public actual val SharedRes.strings.verse_widget_interval_5m: StringResource
  get() = CommonMainStrings12.verse_widget_interval_5m
